import { useState, createContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import img1 from './images/1.png';
import img2 from './images/2.png';
import img3 from './images/3.png';
import img4 from './images/4.png';
import Objektangaben from './pages/mehrfamilienhaus/Objektangaben';
import Grundstucktyp from './pages/grundstuck/Grundstucktyp';
import Wohnung from './pages/wohnung/Wohnung';
import Einfamilienhaus from './pages/einfamilienhaus/Einfamilienhaus';

export const DataContext = createContext();

function App() {
  let [page, setPage] = useState(0);
  let [type, setType] = useState();
  let [grundstucktyp, setGrundstucktyp] = useState('BAULAND ERSCHLOSSEN');
  let [flache, setFlache] = useState();
  let [grundstuck, setGrundstuck] = useState();
  let [anzahlDerEinheiten, setAnzahlDerEinheiten] = useState();
  let [anzahlDerZimmer, setAnzahlDerZimmer] = useState();
  let [selectedYear, setYear] = useState(2023);
  let [zustandDerImmobilie, setZustandDerImmobilie] = useState(
    'RENOVIERUNGSBEDÜRFTIG'
  );
  let [derzeitigeNutzung, setDerzeitigeNutzung] = useState(
    'RENOVIERUNGSBEDÜRFTIG'
  );
  let [gartenBalkon, setGartenBalkon] = useState('GARTEN');

  let choosePage = (page) => {
    setPage(page);
  };

  let previousPage = () => {
    setPage(0);
  };

  const { Provider } = DataContext;
  return (
    <Provider
      value={{
        page,
        type,
        setType,
        grundstucktyp,
        setGrundstucktyp,
        flache,
        setFlache,
        grundstuck,
        setGrundstuck,
        anzahlDerEinheiten,
        setAnzahlDerEinheiten,
        selectedYear,
        setYear,
        zustandDerImmobilie,
        setZustandDerImmobilie,
        derzeitigeNutzung,
        setDerzeitigeNutzung,
        anzahlDerZimmer,
        setAnzahlDerZimmer,
        gartenBalkon,
        setGartenBalkon,
      }}
    >
      <div className='App'>
        {page === 0 && (
          <>
            <h2>
              <strong>WELCHE IMMOBILIE MÖCHTEN SIE BEWERTEN?</strong>
              <hr />
            </h2>

            <div className='choices-list-four flex-container'>
              <div
                className='choice picture'
                onClick={() => choosePage('EINFAMILIENHAUS')}
              >
                <img
                  height={'140px'}
                  width={'140px'}
                  src={img1}
                  alt='EINFAMILIENHAUS'
                />
                <p>EINFAMILIENHAUS</p>
              </div>
              <div
                className='choice picture'
                onClick={() => choosePage('WOHNUNG')}
              >
                <img
                  height={'140px'}
                  width={'140px'}
                  src={img2}
                  alt='WOHNUNG'
                />
                <p>WOHNUNG</p>
              </div>
              <div
                className='choice picture'
                onClick={() => choosePage('MEHRFAMILIENHAUS')}
              >
                <img
                  height={'140px'}
                  width={'140px'}
                  src={img3}
                  alt='MEHRFAMILIENHAUS'
                />
                <p>MEHRFAMILIENHAUS</p>
              </div>
              <div
                className='choice picture'
                onClick={() => choosePage('GRUNDSTÜCK')}
              >
                <img
                  height={'140px'}
                  width={'140px'}
                  src={img4}
                  alt='GRUNDSTÜCK'
                />
                <p>GRUNDSTÜCK</p>
              </div>
            </div>
          </>
        )}
        {page === 'EINFAMILIENHAUS' && (
          <Einfamilienhaus previousPage={previousPage} />
        )}
        {page === 'WOHNUNG' && <Wohnung previousPage={previousPage} />}
        {page === 'MEHRFAMILIENHAUS' && (
          <Objektangaben previousPage={previousPage} />
        )}
        {page === 'GRUNDSTÜCK' && <Grundstucktyp previousPage={previousPage} />}
      </div>
    </Provider>
  );
}

export default App;
